const clean = (value) => String(value || "").trim();

export const isMonitoredCallStillActive = ({
  queueEntries,
  callerId,
  connectedAt,
}) => {
  const expectedCallerId = clean(callerId);
  const expectedConnectedAt = Number(connectedAt || 0);
  if (!expectedCallerId || !expectedConnectedAt) return false;

  return (Array.isArray(queueEntries) ? queueEntries : []).some((entry) => {
    if (clean(entry?.id) !== expectedCallerId ||
        !clean(entry?.answeredBy)) return false;
    const entryConnectedAt = Number(entry?.timeAnswered || 0);
    return entryConnectedAt > 0 &&
      Math.abs(entryConnectedAt - expectedConnectedAt) <= 2;
  });
};
